"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ServiceHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.1
  });
  return <section id="servicepagehero" data-nav="light" ref={ref} className="relative overflow-hidden bg-background text-foreground py-16 sm:py-20 md:py-24 border-b border-border/40">
      {/* Layered decorative background planes */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-32 -left-24 h-96 w-96 rounded-full bg-chart-1/5 blur-3xl" />
        <div className="absolute top-12 right-0 h-80 w-80 rounded-full bg-chart-2/5 blur-2xl" />
        <div className="absolute inset-0 bg-[radial-gradient(var(--border)_1px,transparent_1px)] [background-size:24px_24px] opacity-25" />
      </div>

      <div className="relative mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <div className={`relative rounded-2xl border border-border/80 bg-card/60 p-8 sm:p-12 md:p-16 shadow-lg backdrop-blur-md transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          {/* Breadcrumb row */}
          <div className="mb-6 sm:mb-8">
            <Breadcrumb>
              <BreadcrumbList className="text-xs sm:text-sm font-medium">
                <BreadcrumbItem>
                  <BreadcrumbLink asChild>
                    <Link to="/">Home</Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <span className="text-muted-foreground">Services</span>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <BreadcrumbPage>Basement Remodeling</BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>
          </div>

          {/* Heading */}
          <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight text-foreground text-balance">
            Basement Remodeling in Decatur, GA
          </h1>

          {/* Intro paragraph */}
          <p className="mt-6 max-w-3xl text-base sm:text-lg md:text-xl text-muted-foreground leading-relaxed">
            Convert underutilized lower levels into fully finished living spaces, guest suites, media lounges, and custom entertainment areas designed specifically for Decatur homes.
          </p>
        </div>
      </div>
    </section>;
}